var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEpic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 10,
    fill: "#4E8AFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 29.8333C74 30.3196 73.8068 30.7859 73.463 31.1297C73.1192 31.4735 72.6529 31.6667 72.1667 31.6667H61.1667V40.8333C61.1667 41.3196 60.9735 41.7859 60.6297 42.1297C60.2859 42.4735 59.8196 42.6667 59.3333 42.6667H48.3333V51.8333C48.3333 52.3196 48.1402 52.7859 47.7964 53.1297C47.4525 53.4735 46.9862 53.6667 46.5 53.6667H35.5V62.8333C35.5 63.3196 35.3068 63.7859 34.963 64.1297C34.6192 64.4735 34.1529 64.6667 33.6667 64.6667H20.8333C20.3471 64.6667 19.8808 64.4735 19.537 64.1297C19.1932 63.7859 19 63.3196 19 62.8333C19 62.3471 19.1932 61.8808 19.537 61.537C19.8808 61.1932 20.3471 61 20.8333 61H31.8333V51.8333C31.8333 51.3471 32.0265 50.8808 32.3703 50.537C32.7141 50.1932 33.1804 50 33.6667 50H44.6667V40.8333C44.6667 40.3471 44.8598 39.8808 45.2036 39.537C45.5475 39.1932 46.0138 39 46.5 39H57.5V29.8333C57.5 29.3471 57.6932 28.8808 58.037 28.537C58.3808 28.1932 58.8471 28 59.3333 28H72.1667C72.6529 28 73.1192 28.1932 73.463 28.537C73.8068 28.8808 74 29.3471 74 29.8333Z",
    fill: "#081E38",
    fillOpacity: 0.890196
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpic);
export default __webpack_public_path__ + "static/media/Epic.9210aa6dc2cb4cf0c34ffece77e7633d.svg";
export { ForwardRef as ReactComponent };